import {Api} from './api/api'
import { useParams } from "react-router-dom";

export const api = new Api()

export function useDivisionOrUndefined(): number | undefined {
  const divisionId = useParams().divisionId
  const division = parseInt(divisionId ?? "", 10)
  return isNaN(division) ? undefined : division
}
export function useDivision(): number {
  const division = useDivisionOrUndefined()
  if (division === undefined) {
    throw new Error("Division must be a number")
  }
  return division
}
